import React from "react";
import { observer } from "mobx-react";
import dashboardSettingsStore from "../../stores/dashboard-settings-store";
import { CapabilityTypeMap, PROFILE_CAPABILITIES } from "../../models/ProfileCapabilities";

/**
 * ResolveCapability Component
 *
 * A helper component that resolves behavior profile capabilities and provides
 * type-safe access through a render prop pattern. The capability type is
 * automatically inferred from the capability prop.
 *
 * @example
 * <ResolveCapability capability={PROFILE_CAPABILITIES.PRODUCT_EXCHANGE}>
 *     {(resolved) => (
 *         resolved.isShopNowSupported && resolved.isFeatureEnabled && (
 *             <>// children</>
 *         )
 *     )}
 * </ResolveCapability>
 */
interface IResolveCapabilityProps<T extends PROFILE_CAPABILITIES> {
	capability: T;
	children: (resolved: CapabilityTypeMap[T]) => React.ReactNode;
}

function ResolveCapability<T extends PROFILE_CAPABILITIES>({
	                                                           capability,
	                                                           children
                                                           }: IResolveCapabilityProps<T>): React.ReactElement {
	const resolved = dashboardSettingsStore.resolveCapability(capability);
	return <>{children(resolved)}</>;
}

export default observer(ResolveCapability);